import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type FindUsersParams = {
  organizationId: string;
  filters: Record<string, unknown>;
};

function getUsersHelper(organizationId: string) {
  return clientApi.getOCClient().helpers.employer.organizations.id(organizationId).users;
}

const { useFind: useOrganizationUsers, useDelete: useOrganizationUserRemove } = getCRUDHooks({
  entityName: 'organizationUser',
  find: ({ organizationId, filters }: FindUsersParams) =>
    getUsersHelper(organizationId).find(filters),
  remove: ({ organizationId, userId }) => getUsersHelper(organizationId).delete(userId),
});

export { useOrganizationUsers, useOrganizationUserRemove };
